import { Box as MuiBox, styled, Typography } from "@mui/material"
import { BoxProps } from "@mui/system";
import { FC } from "react";
import { EquipmentColors } from "../../../app/config/enum";

interface Props {
    value: number;
}

const Box = styled(MuiBox)<Props>(({theme, value}) => {
    let barColor = EquipmentColors.Red;
    
    if (value >= 90) {
        barColor = EquipmentColors.Green
    } else if (value >= 70) {
        barColor = EquipmentColors.Yellow
    } else if (value >= 50) {
        barColor = EquipmentColors.Orange
    } else {
        barColor = EquipmentColors.Red
    }
    
    return ({
        width: '100%',
        minWidth: '80px',
        maxWidth: '150px',
        height: '20px',
        border: `1px solid ${theme.palette.divider}`,
        display: 'block',
        borderRadius: '7px',
        position: 'relative',
        overflow: 'hidden',
        '.RKD-Progressbar-progress': {
            width: `${value}%`,
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            borderRadius: '7px',
            backgroundColor: barColor,
        },
        '.RKD-Progressbar-percentage': {
            position: 'absolute',
            display: 'block',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
    })
})

export const HomeProgressBar: FC<Props & BoxProps> = ({ value, ...props }) => {
    return (
        <Box component="span" value={value} {...props}>
            <MuiBox component="span" className="RKD-Progressbar-progress" />
            <Typography fontSize="small" fontWeight={600} className="RKD-Progressbar-percentage">{value}%</Typography>
        </Box>
    )
}